export const SET_TOKEN_SUCCESS = 'SET_TOKEN_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const SET_USER_SUCCESS = 'SET_USER_SUCCESS'
